import Vue from 'vue'
import Router from 'vue-router'
import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/components/containers/DefaultContainer')

const ViewStaffDashboard = () => import('./staff/dashboard')
const ViewStaffConfiguration = () => import('./staff/configuration')
const ViewStaffManualSend = () => import('./staff/manualSend')
const ViewStaffInbox = () => import('./staff/inbox')
const ViewStaffEventTypes = () => import('./staff/eventTypes')
const ViewStaffLog = () => import('./staff/log')

Vue.use(Router)

const router =
  [
    {
      path: '/st/notifications',
      component: DefaultContainer,
      children: [
        {
          path: '',
          name: 'NotificationsStaffDashboard',
          component: ViewStaffDashboard,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Notificaciones',
          }          
        },
        {
          path: 'configurations',
          name: 'NotificationsStaffConfigurations',
          component: ViewStaffConfiguration,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Configuraciones de Notificaciones',
          }
        },   
        {
          path: 'manual-send',
          name: 'NotificationsStaffManualSend',
          component: ViewStaffManualSend,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Envío Manual de Notificaciones',
          }
        },
        {
          path: 'inbox',
          name: 'NotificationsStaffInbox',
          component: ViewStaffInbox,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Mis Notificaciones',
          }
        },
        {
          path: 'event-types',
          name: 'NotificationsStaffEventTypes',
          component: ViewStaffEventTypes,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Destinatarios de Notificaciones',
          }
        },
        {
          path: 'log',
          name: 'NotificationsStaffLog',
          component: ViewStaffLog,
          beforeEnter: Permisos.IS_PERSONAL,
          meta: {
            title: 'Log de Notificaciones',
          }
        },
      ]
    },

    {
      path: '/cu/notifications',
      component: DefaultContainer,
      children: [

      ]
    },

    {
      path: '/su/notifications',
      component: DefaultContainer,
      children: [

      ]
    },
  ]

export default router
